import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_CREDIT } from '@/modules/credit/ticket/router';
import { creditService } from '@/services/credit';
import useVuelidate from '@vuelidate/core';
import { minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useCreditTicketAdd() {
    const router = useAppRouter();

    const model = reactive({
        name: '',
        amount: 0
    });

    const validations = {
        name: { required },
        amount: { required, numeric, min: minValue(1) }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () => creditService.ticket.create(model.name, model.amount),
        onSuccess: () => router.push({ name: ROUTE_NAME_CREDIT.TICKET.INDEX })
    });

    return { model, v$, create };
}
